"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "arpaise": {
    "b28d0ef1": [{
      "hkey": "9223ca8a",
      "slug": "arpaise",
      "name": "Arpaise",
      "primary": true,
      "skipSearch": false
    }],
    "covini": [{
      "hkey": "9223ca8a",
      "slug": "arpaise",
      "name": "Arpaise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d15b27ba": [{
      "hkey": "9223ca8a",
      "slug": "arpaise",
      "name": "Arpaise",
      "primary": true,
      "skipSearch": false
    }],
    "mignoli": [{
      "hkey": "9223ca8a",
      "slug": "arpaise",
      "name": "Arpaise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "930b7ac1": [{
      "hkey": "9223ca8a",
      "slug": "arpaise",
      "name": "Arpaise",
      "primary": true,
      "skipSearch": false
    }],
    "russi": [{
      "hkey": "9223ca8a",
      "slug": "arpaise",
      "name": "Arpaise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;